import React from "react";
import { motion } from "framer-motion";
import { PencilSquare, Trash } from "react-bootstrap-icons";

const SystemEmailTemplates = () => {
  const templates = [
    "Email Verification",
    "Welcome Email",
    "Leave Request",
    "Performance Review",
    "Training Session",
    "Password Reset",
  ];

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.div
        className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          Email template
        </motion.h5>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-primary btn-sm"
        >
          + Add template
        </motion.button>
      </motion.div>

      {/* TEMPLATE CARDS */}
      <div className="row g-3">
        {templates.map((item, i) => (
          <div className="col-md-4" key={i}>
            <motion.div
              className="card shadow-sm border-0 h-100"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.02 }}
            >
              <div className="card-body d-flex justify-content-between align-items-center">
                <span className="fw-medium">{item}</span>

                <div className="d-flex gap-2">
                  <motion.div whileHover={{ scale: 1.2 }}>
                    <PencilSquare className="text-primary" />
                  </motion.div>

                  <motion.div whileHover={{ scale: 1.2 }}>
                    <Trash className="text-danger" />
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default SystemEmailTemplates;
